const axios = require("axios");
// import store from "../store/store";
const store = require("../store/store");
// All other requests exept sing-in and sign-up
var allReq = axios.create({
  baseURL: "/api",
  // timeout: 10000
  // headers: { athorization: localStorage.getItem("MashToken") }
});
allReq.interceptors.request.use(function(req) {
  // console.log(store.default.getters.showToken);
  req.headers.common.athorization = store.default.getters.showToken;
  // console.log(req);
  return req;
});

allReq.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    // Do something with response error
    // console.log(error.response);
    if (error.response && error.response.status === 401)
      store.default.commit("OnLogout");
    return Promise.reject(error);
  }
);

const logInReq = axios.create({
  baseURL: "/api",
});

function getReq(url) {
  // allReq.defaults.headers.common.athorization = store.getters.showToken;
  return allReq.get(url);
}
function postReq(url, postData) {
  try {
    return allReq.post(url, postData);
  } catch (error) {
    // console.log(error);
  }
}
function putReq(url, putData) {
  return allReq.put(url, putData);
}
function delReq(url, delData) {
  return allReq.delete(url + "/" + delData);
}
function findReq(url, delData) {
  return allReq.get(url + "/" + delData);
}

module.exports = {
  allReq,
  logInReq,
  getReq,
  postReq,
  putReq,
  delReq,
  findReq,
};
